import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ServiceDetailsPage = lazy(() => import('../pages/service-details/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/service/:serviceId',
    element: <ServiceDetailsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;